export default [
	{
		path: '/change_password/:token',
		lazy: async () => {
			const Module = await import('../../pages/services/account/ChangePasswordPage');
			return { Component: Module.default };
		},
	},
];
